import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import TextGroup from '../../molecules/TextGroup';

import styles from './AlreadySignupBlock.module.scss';
import usePresenter from './AlreadySignupBlock.presenter';
import getProps from './AlreadySignupBlock.props';
import { AlreadySignupBlockCombinedProps } from './types';


const AlreadySignupBlock: React.FC<AlreadySignupBlockCombinedProps> = (props) => {
  const {
    className,
    classes,
    stepperText,
    textGroup,
    button,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.alreadySignupBlock;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <Text
          className={cx(styles.stepperText, classes?.stepperText)}
          {...internalProps.stepperText}
          {...stepperText}/>
        <TextGroup
          className={cx(styles.textGroup, classes?.textGroup)}
          {...internalProps.textGroup}
          {...textGroup}/>
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}/>
      </div>
    </div>
  );
};

export default AlreadySignupBlock;

